import styled from "styled-components";
import WrapperContainer from "../Containers/WrapperContainer";
import { device } from "../../services";

export const DateRangeInputWrapper = styled(WrapperContainer)`
  @media screen and ${device.mobile} {
    flex-direction: column;
  }
`;
